var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title-line",class:_vm.textStyle},[_c('div',{staticClass:"title-line__border"}),_vm._v(" "),_c('div',{staticClass:"title-line__text",class:_vm.background},[_vm._v("\n    "+_vm._s(_vm.text)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }